import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthDataForm } from '@app/store/models/auth-data.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-auth-password-inputs',
  templateUrl: './auth-password-inputs.component.html',
  styleUrls: ['./../auth.global.scss', './auth-password-inputs.component.scss']
})
export class AuthPasswordInputsComponent implements OnInit, OnDestroy {

  @Input() label = "Password"
  private subscriptions: Subscription[] = []
  passwordtype: "password" | "text" = "password"
  cpasswordtype: "password" | "text" = "password"
  @Input() data: FormGroup<AuthDataForm>

  constructor() {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.data.controls.password.valueChanges.subscribe(vv => this.checkpassword()))
    this.subscriptions.push(this.data.controls.cpassword.valueChanges.subscribe(vv => this.checkpassword()))
    this.checkpassword()
  }

  ngOnDestroy(): void {
    this.subscriptions.map(sub => sub.unsubscribe())
  }

  private checkpassword() {
    this.data.get("password_strength").setValue(0)
    const password = this.data.get("password").value
    if (password.match(/[a-z]+/)) {
      this.data.get("password_strength").setValue(this.data.get("password_strength").value + 20)
    }
    if (password.match(/[A-Z]+/)) {
      this.data.get("password_strength").setValue(this.data.get("password_strength").value + 20)
    }
    if (password.match(/[0-9]+/)) {
      this.data.get("password_strength").setValue(this.data.get("password_strength").value + 20)
    }
    if (password.match(/[$@#&!]+/)) {
      this.data.get("password_strength").setValue(this.data.get("password_strength").value + 20)
    }
    if (password.length >= 8) {
      this.data.get("password_strength").setValue(this.data.get("password_strength").value + 20)
    }
  }

}
